<template>
  <scroll-right-frame>
    <div class="rp-wrapper">
      <div class="rp-header">
        <span class="rp-header-title">消息发送</span>
      </div>
      <div class="rp-body">
        频道：
        <div>
          <el-radio v-for="c in channels" :key="c" v-model="channel" :label="c" border size="medium">{{ c }}</el-radio>
        </div>
        <br>
        内容：
        <div style="width: 490px;">
          <el-input v-model="message" placeholder="请输入内容" type="textarea" :rows="6"></el-input>
        </div>
        <br>
        <div>
          <el-button type="primary" @click="handleSendMsg">发送</el-button>
        </div>
        <div style="margin-top: 50px;">
          <el-button type="primary" @click="handleSendServerMsg">发送50条系统通知</el-button>
        </div>
      </div>
      <div class="rp-footer">
      </div>
    </div>
  </scroll-right-frame>
</template>
<script>
  import ScrollRightFrame from '../../../../components/scroll-right-frame'
  import util from '../../../../libs/util'

  export default {
    name: 'test-ws-sender',
    components: {ScrollRightFrame},
    data() {
      return {
        channel: 'test-ws-channel-1',
        channels: [
          'test-ws-channel-1',
          'test-ws-channel-2',
          'serverNotice'
        ],
        message: ''
      }
    },
    methods: {
      handleSendMsg() {
        if (!this.message) {
          this.$message.warning('要发送的消息为空！')
          return
        }
        let params = {
          msg: this.message,
          channel: this.channel
        }
        util.ajax.post('/demo/demoSendWebSocketMessage/send', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$message.success('发送成功')
          } else {
            this.$message.warning('发送失败！')
          }
        }).catch((err) => {
          console.error(err)
          this.$message.error('发送失败')
        })
      },
      handleSendServerMsg() {
        let prefix = this.message || '系统通知'
        this.channel = 'serverNotice'
        for (let i = 1; i <= 50; i++) {
          this.message = prefix + '：' + i
          this.handleSendMsg()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/demo/websocket/test-ws-sender.vue